export default __webpack_public_path__ + "static/media/suntek_ultra.a65ef36f.webp";